import commonUtil from '../../../../../utils/commonUtil';

export const UPDATE_OWNER_DETAILS = 'UPDATE_OWNER_DETAILS';
export const SAVE_OWNER_DETAILS_LOAD = 'SAVE_OWNER_DETAILS_LOAD';
export const SAVE_OWNER_DETAILS_LOAD_SUCCESS = 'SAVE_OWNER_DETAILS_LOAD_SUCCESS';
export const SAVE_OWNER_DETAILS_LOAD_FAIL = 'SAVE_OWNER_DETAILS_LOAD_FAIL';

export const ADD_OWNER_DETAILS = 'SAVE_OWNER_DETAILS';
export const ADD_OWNER_DETAILS_SUCCESS = 'SAVE_OWNER_DETAILS_SUCCESS';
export const ADD_OWNER_DETAILS_FAIL = 'SAVE_OWNER_DETAILS_FAIL';

export const ADD_CO_OWNER_LOAD = 'ADDCOOWNER_LOAD';
export const ADD_CO_OWNER_LOAD_SUCCESS = ' ADDCOOWNER_LOAD_SUCCESS';
export const ADD_CO_OWNER_LOAD_FAIL = ' ADDCOOWNER_LOAD_FAIL';

export const SEND_EMAIL_TO_CO_OWNER_LOAD = 'SEND_EMAIL_TO_CO_OWNER';
export const SEND_EMAIL_TO_CO_OWNER_SUCCESS = 'SEND_EMAIL_TO_CO_OWNER_SUCCESS';
export const SEND_EMAIL_TO_CO_OWNER_FAIL = 'SEND_EMAIL_TO_CO_OWNER_FAIL';

const COOWNERELIGIBLE = '/api/EventCreation/isCoOwnerEligible';
const ADDCOOWNERTOEVENT = '/api/EditEvent/addCoOwnerToEvent';
const SAVEOWNERDETAILS = '/api/EditEvent/saveOwnerDetails';
const SENDEMAILTOCOOWNER = '/api/triggerEmail/sendMailToCoOwner';
const ISPROFILEVERIFIED = '/api/currentUser/isProfileVerified';

export function updateOwnerDetails(userDetail, profileId) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.ownerId = userDetail.ownerId;
  payload.ownerTitle = userDetail.ownerTitle;
  if (userDetail.iscoOwner === 'false' || userDetail.ownerHasPermission) {
    payload.ownerHasPermission = 'true';
    payload.ownerEmail = userDetail.ownerEmail;
  } else {
    payload.ownerEmail = userDetail.ownerEmail;
    payload.ownerHasPermission = userDetail.ownerHasPermission.toString();
  }
  if (userDetail.profileId || profileId) {
    payload.profileId = profileId || userDetail.profileId;
  }
  payload.ownerfirstName = userDetail.ownerfirstName;
  payload.ownerlastName = userDetail.ownerlastName;
  payload.nickName = userDetail.ownerNickName;
  payload.ownerMotherName = userDetail.ownerMotherName;
  payload.ownerDateofbirth = userDetail.ownerDateofbirth;
  payload.ownerPhone = userDetail.ownerPhone;
  return commonUtil.triggerServerRequest({ url: SAVEOWNERDETAILS, method: 'POST', data: payload });
}

export function sendEmailToCoOwner(eventId, emailId) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.eventId = eventId;
  payload.emailId = emailId;
  return commonUtil.triggerServerRequest({ url: SENDEMAILTOCOOWNER, method: 'POST', data: payload });
}


export function getCoOwnerProfileId(emailId) {
  const payload = {};
  payload.brandName = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.email = emailId;
  return commonUtil.triggerServerRequest({ url: ISPROFILEVERIFIED, method: 'POST', data: payload });
}

// FOR Add CoOwner To Event
export function addCoOwnerDetails(userDetail, eventId, profileId) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.eventId = eventId;
  payload.title = userDetail.ownerTitle;
  if (userDetail.ownerHasPermission) {
    payload.ownerHasPermission = 'true';
  }
  if (profileId) {
    payload.profileId = profileId;
  }
  payload.celebfirstName = userDetail.ownerfirstName;
  payload.celeblastName = userDetail.ownerlastName;
  payload.celebmotherName = userDetail.ownerMotherName;
  payload.celebdateofbirth = userDetail.ownerDateofbirth;
  payload.celebphone = userDetail.ownerPhone;
  payload.ownerEmail = userDetail.ownerEmail;
  payload.celebnickName = userDetail.ownerNickName;
  payload.ownerLabel = userDetail.ownerLabel;
  return commonUtil.triggerServerRequest({ url: ADDCOOWNERTOEVENT, method: 'POST', data: payload });
}

// is CoOwner Eligible
export function isCoOwnerEligible(emailId, eventType) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.eventType = eventType;
  payload.emailId = emailId;
  return commonUtil.triggerServerRequest({ url: COOWNERELIGIBLE, method: 'POST', data: payload });
}
